import { Input } from "@rumbledirect/ui";
import { type ChangeEvent } from "react";
import { Question } from "survey-core";

export class TimePickerQuestionModel extends Question {
  getType() {
    return "timepicker";
  }
}

interface TimePickerQuestionProps {
  question: TimePickerQuestionModel;
}

export const TimePickerQuestion = (props: TimePickerQuestionProps) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    props.question.value = e.target.value || undefined;
  };

  return (
    <Input
      styles={{ root: { fontWeight: 500 } }}
      id={props.question.inputId}
      type="time"
      disabled={props.question.isDisabledAttr || props.question.isReadOnlyAttr}
      readOnly={props.question.isReadOnlyAttr}
      value={props.question.value ?? ""}
      style={props.question.inputStyle}
      onBlur={(e) => props.question.onBlur(e)}
      onFocus={(e) => props.question.onFocus(e)}
      onChange={handleChange}
      onClick={props.question.readOnlyBlocker}
      onPointerDown={props.question.readOnlyBlocker}
      aria-required={props.question.a11y_input_ariaRequired}
      aria-label={props.question.a11y_input_ariaLabel}
      aria-labelledby={props.question.a11y_input_ariaLabelledBy}
      aria-describedby={props.question.a11y_input_ariaDescribedBy}
      aria-invalid={props.question.a11y_input_ariaInvalid}
      aria-errormessage={props.question.a11y_input_ariaErrormessage}
    />
  );
};
